import embeddedService from '@app/libs/embedded/embeddedService';

interface RedirectOptions {
  query?:
    | {
        documentId: string;
        eventType:
          | 'document_started'
          | 'document_signed'
          | 'document_all_signed'
          | 'document_rejected'
          | 'document_signing_canceled';
      }
    | { templateId: string; eventType: 'template_created' | 'template_edited' };
}

export default function redirect(baseUrl: string, options?: RedirectOptions) {
  const url = new URL(baseUrl);

  if (options?.query) {
    const { query } = options;
    Object.keys(query).forEach((key) =>
      url.searchParams.append(key, (query as Record<string, string>)[key])
    );
  }

  if (embeddedService.isEmbedded) {
    embeddedService.clear();
  }
  window.location.assign(url.toString());
}
